/**
 * @desc 基座应用骨架页
 * @time 2023-07-31 15:48:06
 * @user simxin
 */

import { LayoutSider, LayoutContent } from '@src/component/layout/full';
import { LayoutMenu } from '@src/component/layout/menu';
import { LayoutLand } from '@src/component/layout/land';
import { ErrorStatus, LoadingStatus } from '@src/component/loading';
import { usePortalStore } from '@src/store';
import { useBanned } from '@src/hooks/useBanned';
import { Banned } from '@src/component/banned/banned';
import { useState, useEffect } from 'react';

export const Products = () => {
  const errorPortal = usePortalStore(state => state.errorPortal);
  const { loading, isBanned } = useBanned();
  const [showMenu, setShowMenu] = useState(false);
  const [disabledPaths, setDisabledPaths] = useState<string[]>([]);

  useEffect(() => {
    const handleShowMenu = (e: Event) => {
      setShowMenu(true);
      const detail = (e as CustomEvent)?.detail;
      if (detail?.data?.disabledPaths) {
        setDisabledPaths(detail.data.disabledPaths || []);
      }
    };
    document.body?.addEventListener('showMenu', handleShowMenu);
    return () => {
      document.body?.removeEventListener('showMenu', handleShowMenu);
    };
  }, []);

  if (errorPortal) return <ErrorStatus />;
  if (loading) return <LoadingStatus />;
  if (isBanned) return <Banned />;

  return (
    <>
      {showMenu && (
        <LayoutSider>
          <LayoutMenu disabledPaths={disabledPaths} />
        </LayoutSider>
      )}
      <LayoutContent>
        <LayoutLand />
      </LayoutContent>
    </>
  );
};
